import {useEffect} from "react";

export function BackTop() {
  useEffect(() => {
    const el = document.getElementById("backTop");
    if(!el) return;
    function onClick(e: Event) {
      e.preventDefault();
      window.scrollTo({top: 0, behavior: "smooth"});
    }
    el.addEventListener("click", onClick);
    return () => el.removeEventListener("click", onClick);
  }, []);
  return <a href="#" className="anim" id="backTop"><i className="fa fa-angle-up" /></a>;
}
